import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ShopSidebarService } from '../../services/shop-sidebar.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { data } from 'src/app/data';

export type Layout = 'grid'|'grid-with-features'|'list';

@Component({
    selector: 'app-products-list',
    templateUrl: './products-list.component.html',
    styleUrls: ['./products-list.component.scss'],
})
export class ProductsListComponent implements OnInit, OnDestroy {
    @Input() layout: Layout = 'grid';
    @Input() grid: 'grid-3-sidebar'|'grid-4-full'|'grid-5-full' = 'grid-5-full';
    @Input() offcanvas: 'always'|'mobile' = 'mobile';
    @Input() showpagination: boolean = true;
   

    destroy$: Subject<void> = new Subject<void>();

    listOptionsForm: FormGroup;
    filtersCount = 0;

    @Input() public datanew :any;
    
    constructor(
        private fb: FormBuilder,
        public sidebar: ShopSidebarService,
        private router:Router,
    ) { 
    }

    ngOnInit(): void {
        if(this.showpagination){
            this.listOptionsForm = this.fb.group({
                page: this.fb.control(this.datanew.pagination.page),
                limit: this.fb.control(this.datanew.pagination.limit),
                sort: this.fb.control(this.datanew.pagination.sort),
            });
            this.listOptionsForm.valueChanges.subscribe(value => {
                var routerurl =  (this.router.url.split("?"))[0];
                this.router.navigate([routerurl],{queryParams:value});
            });
        }
        else{
            this.listOptionsForm =this.fb.group({})
        }
        
console.log('jd',this.datanew)
        
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
    
    setLayout(value: Layout): void {
        this.layout = value;
    }
}
